// extracted by mini-css-extract-plugin
export default {"profilePhoto":"FZSVC6","isCenterAlignment":"eUtQbB","isRightAlignment":"E01poy","noTitle":"MPJuUz"};